<header class="header">
  <p-menubar
    [model]="items()"
    class="custom-menubar"
    [style]="{'border:': 'none'}"
    data-testid="main-navigation-menubar"
  >
    <ng-template #start>
      <img src="/images/color-logo.svg" alt="Logo" class="logo" />
    </ng-template>

    <ng-template #end>
      <div class="flex items-center gap-2">
        <app-provider-tenant-switcher></app-provider-tenant-switcher>
        <app-user-context-menu></app-user-context-menu>
      </div>
    </ng-template>
  </p-menubar>
</header>
